import { FC, useEffect, useState } from 'react';

import { SkeletonList } from '@/shared';
import { useTeamStore } from '@/stores';

import Header from './layout/01-Header';
import TeamList from './layout/02-Content/views/TeamList';
import Metadata from './meta';

const TeamsList: FC = (): JSX.Element => {
    const [searchInput, setSearchInput] = useState('');
    const [open, setOpen] = useState(false);

    const { fetchTeams, teams, loading } = useTeamStore();

    useEffect(() => {
        fetchTeams();
    }, []);

    const searchedTeams =
        searchInput !== ''
            ? teams.filter((team) => team?.name?.toLowerCase().includes(searchInput.toLowerCase()))
            : teams;

    return (
        <>
            <Metadata />
            <Header teams={teams} input={searchInput} setInput={setSearchInput} open={open} setOpen={setOpen} />
            {loading ? <SkeletonList listLength={12} minHeight='30rem' /> : <TeamList teams={searchedTeams} />}
        </>
    );
};

export default TeamsList;
